import { render, staticRenderFns } from "./DetalhesTarefasModal.vue?vue&type=template&id=d50c7a1c&scoped=true&"
import script from "./DetalhesTarefasModal.vue?vue&type=script&lang=js&"
export * from "./DetalhesTarefasModal.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesTarefasModal.vue?vue&type=style&index=0&id=d50c7a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50c7a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VDatePicker,VDialog,VDivider,VFlex,VIcon,VLayout,VMenu,VSpacer,VSubheader,VTextField,VTextarea})
